import { render, staticRenderFns } from "./CollapseButtons.vue?vue&type=template&id=9471add4&scoped=true"
import script from "./CollapseButtons.vue?vue&type=script&lang=js"
export * from "./CollapseButtons.vue?vue&type=script&lang=js"
import style0 from "./CollapseButtons.vue?vue&type=style&index=0&id=9471add4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9471add4",
  null
  
)

export default component.exports